
import { Component, Prop, Watch, BaseMixins, Provide } from "@/lib";
import { warn } from "vue-class-component/lib/util";
import utils from "@/lib/utils/types/utils";
@Component({ name: "form-modal" })
export default class FormModal extends BaseMixins {
  /*是否显示模态框*/
  @Prop({ type: Boolean, default: false, required: true }) isShow: boolean;
  /*模态框 title多语言key*/
  @Prop({ type: String }) modelTitleL: string;
  /*标签的宽度 默认150*/
  @Prop({ type: Number, default: 120 }) labelWidth: number;
  /*Modal的宽度 520*/
  @Prop({ type: Number, default: 520 }) width: number;
  /*ok text key*/
  @Prop({ type: String, default: "Action.Save" }) okText: string;
  /*cancel text key*/
  @Prop({ type: String, default: "Action.Cancel" }) cancelText: string;
  /** 成功提示消息文本 */
  @Prop({ type: String, default: "Tip.SavedSuccessfully" }) successMsgText: string;
  /** 表单模型 */
  @Prop({ type: Object, required: true }) model: any;
  /** ok dispatch type 需要操作数据库时 */
  @Prop({ type: String }) okAction: string;
   /*不显示取消 按钮*/
  @Prop({ type: Boolean }) isHideOk: boolean;
  /*不显示OK 按钮*/
  @Prop({ type: Boolean }) isHideCancel: boolean;
  /*提交成功后，是否需连同接口返回值一起返回*/
  @Prop({ type: Boolean, default: false }) isReturnApiResult: boolean;

  loading: boolean = false;

  @Provide("modelValidateError")
  modelValidateError: any = { error: {} };

  ok() {
    this.formValidate(async (model: any) => {
      if (this.okAction) {
        try {
          this.loading = true;
          await this.$store
            .dispatch({ type: this.okAction, data: this.model })
            .then((response) => {
              this.$Message.success(this.L(this.successMsgText));
              if (this.isReturnApiResult) {
                this.$emit("save-success", model, response);
              } else {
                this.$emit("save-success", model);
              }

              (this.$refs["formModal"] as any).resetFields();
            })
            .finally(() => {
              this.loading = false;
            });
        } catch (e:any) {
          if (!e.response) return;
          let tempValidateError = e.response.modelValidationErrors;
          //业务逻辑验证
          if (tempValidateError) {
            for (let key in tempValidateError) {
              tempValidateError[key] = tempValidateError[key] + "_" + this.$util.guid(); //添加guid 触发 控件基类FormComponentBase  中的watch
            }
            Object.assign(this.modelValidateError, { error: tempValidateError });
          } else {
            this.$emit("save-error", e);
          }
        }
      } else {
        this.$emit("save-success", model);
      }
    });
  }

  cancel() {
    (this.$refs["formModal"] as any).resetFields();
    (this.$parent as any).close();
  }

  formValidate(callback?: Function) {
    (this.$refs["formModal"] as any).validate(async (valid: boolean) => {
      if (valid) {
        if (callback) {
          callback(Object.assign({}, this.model));
        }
      }
    });
  }

  validateField(propName: string) {
    (this.$refs["formModal"] as any).validateField(propName)
  }

  visibleChange(value) {
    this.$emit("on-visible-change", value);
  }
}
